import { render, staticRenderFns } from "./GradeHistory.vue?vue&type=template&id=4f1e0adc&scoped=true&"
import script from "./GradeHistory.vue?vue&type=script&lang=js&"
export * from "./GradeHistory.vue?vue&type=script&lang=js&"
import style0 from "./GradeHistory.vue?vue&type=style&index=0&id=4f1e0adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e0adc",
  null
  
)

export default component.exports